import {
  IconAdjustmentsHorizontal,
  IconAlertTriangleFilled,
  IconArrowBarToDown,
  IconArrowDown,
  IconArrowDownCircle,
  IconArrowLeft,
  IconArrowNarrowDown,
  IconArrowNarrowUp,
  IconArrowRight,
  IconArrowRightCircle,
  IconArrowUp,
  IconArrowsSort,
  IconArrowsUpDown,
  IconBell,
  IconBuilding,
  IconBuildingBank,
  IconBuildingSkyscraper, // Note: The image shows a colored version of this icon
  IconBuildingStore,
  IconCalendar,
  IconCalendarWeek,
  IconCamera,
  IconCash, // Note: The image shows a colored version of this icon
  IconCheck,
  IconChevronDown,
  IconChevronLeft,
  IconChevronRight,
  IconChevronUp, // Note: The image shows this with a custom red background
  IconCircleCheckFilled,
  IconCircleFilled,
  IconCircleX,
  IconCircleXFilled,
  IconClipboard,
  IconClipboardOff,
  IconCloud,
  IconCloudUpload,
  IconCopy,
  IconCreditCard,
  IconDeviceFloppy,
  IconDots,
  IconDotsVertical,
  IconDownload,
  IconEdit,
  IconEye,
  IconEyeOff,
  IconEyeClosed,
  IconFile,
  IconFileCheck,
  IconFileOff,
  IconFilePlus,
  IconFileSearch,
  IconFileStack,
  IconFileTypeDoc,
  IconFileTypeDocx,
  IconFileTypeJpg,
  IconFileTypePdf,
  IconFileTypePng,
  IconFileTypeZip,
  IconFiles,
  IconFolderCog,
  IconFolder,
  IconHandMove,
  IconHome,
  IconHomeEco,
  IconInfoCircle,
  IconLayoutGrid,
  IconLayoutList,
  IconLink,
  IconLock,
  IconLockPassword,
  IconLogin,
  IconLogout,
  IconMapPin,
  IconMenu2,
  IconMessage,
  IconMessage2,
  IconMessageCircle,
  IconMessageQuestion,
  IconMessageReport,
  IconMessageX,
  IconMicrophone,
  IconNoteOff,
  IconPaperclip,
  IconPencil,
  IconPhone,
  IconPhoto,
  IconPlus,
  IconReceipt,
  IconRefresh,
  IconRepeat,
  IconRobot, // Note: The image shows a colored version of this icon
  IconScale,
  IconSearch,
  IconSeedling,
  IconSend,
  IconSettings,
  IconSignature,
  IconStar,
  IconStarFilled,
  IconTrash,
  IconTruck, // Note: The image shows a colored version of this icon
  IconUpload,
  IconUserCheck,
  IconUserCircle,
  IconUserDown,
  IconUserEdit,
  IconUserShield,
  IconUserPlus,
  IconUserStar,
  IconWritingSign,
  IconX,
  IconZoomIn,
  IconZoomOut,
  IconLeaf,
  IconSignLeft,
  IconCurrentLocation,
  IconRuler,
  IconStack2,
  IconTools,
  IconWorldLatitude,
  IconArrowBackUp,
  IconArrowForwardUp,
  IconMapPinStar,
} from 'angular-tabler-icons/icons';

// for import in app.config.ts
export const IconsList = {
  IconAdjustmentsHorizontal,
  IconAlertTriangleFilled,
  IconArrowBarToDown,
  IconArrowDown,
  IconArrowDownCircle,
  IconArrowLeft,
  IconArrowRight,
  IconArrowRightCircle,
  IconArrowUp,
  IconArrowsUpDown,
  IconArrowNarrowUp,
  IconArrowNarrowDown,
  IconArrowsSort,
  IconBell,
  IconBuilding,
  IconBuildingBank,
  IconBuildingSkyscraper,
  IconBuildingStore,
  IconCalendar,
  IconCalendarWeek,
  IconCamera,
  IconCash,
  IconCheck,
  IconChevronDown,
  IconChevronLeft,
  IconChevronRight,
  IconChevronUp,
  IconClipboard,
  IconClipboardOff,
  IconCircleFilled,
  IconCircleCheckFilled,
  IconCircleX,
  IconCircleXFilled,
  IconCloud,
  IconCloudUpload,
  IconCopy,
  IconCreditCard,
  IconDeviceFloppy,
  IconDots,
  IconDotsVertical,
  IconDownload,
  IconEdit,
  IconEye,
  IconEyeOff,
  IconEyeClosed,
  IconFile,
  IconFiles,
  IconFileCheck,
  IconFileOff,
  IconFilePlus,
  IconFileSearch,
  IconFileStack,
  IconFileTypeDoc,
  IconFileTypeDocx,
  IconFileTypeZip,
  IconFileTypePdf,
  IconFileTypeJpg,
  IconFileTypePng,
  IconFolderCog,
  IconFolder,
  IconHandMove,
  IconHome,
  IconHomeEco,
  IconInfoCircle,
  IconLayoutGrid,
  IconLayoutList,
  IconLink,
  IconLock,
  IconLockPassword,
  IconLogin,
  IconLogout,
  IconMapPin,
  IconMenu2,
  IconMessage,
  IconMessage2,
  IconMessageCircle,
  IconMessageReport,
  IconMicrophone,
  IconPaperclip,
  IconPencil,
  IconPhone,
  IconPhoto,
  IconPlus,
  IconRefresh,
  IconReceipt,
  IconRepeat,
  IconRobot,
  IconScale,
  IconSeedling,
  IconSearch,
  IconSend,
  IconSettings,
  IconSignature,
  IconStar,
  IconStarFilled,
  IconTrash,
  IconTruck,
  IconUpload,
  IconUserCheck,
  IconUserCircle,
  IconUserDown,
  IconUserPlus,
  IconUserStar,
  IconUserEdit,
  IconUserShield,
  IconWritingSign,
  IconX,
  IconZoomIn,
  IconZoomOut,
  IconMessageX,
  IconNoteOff,
  IconMessageQuestion,
  IconLeaf,
  IconSignLeft,
  IconCurrentLocation,
  IconRuler,
  IconStack2,
  IconTools,
  IconWorldLatitude,
  IconArrowForwardUp,
  IconArrowBackUp,
  IconMapPinStar,
};

export enum TablerIcon {
  AdjustmentsHorizontal = 'adjustments-horizontal',
  AlertTriangleFilled = 'alert-triangle-filled',
  ArrowBarToDown = 'arrow-bar-to-down',
  ArrowDown = 'arrow-down',
  ArrowDownCircle = 'arrow-down-circle',
  ArrowLeft = 'arrow-left',
  ArrowRight = 'arrow-right',
  ArrowRightCircle = 'arrow-right-circle',
  ArrowUp = 'arrow-up',
  ArrowUpDown = 'arrows-up-down',
  ArrowNarrowUp = 'arrow-narrow-up',
  ArrowNarrowDown = 'arrow-narrow-down',
  ArrowsSort = 'arrows-sort',
  ArrowBackUp = 'arrow-back-up',
  ArrowForwardUp = 'arrow-forward-up',
  Bell = 'bell',
  Building = 'building',
  BuildingBank = 'building-bank',
  BuildingSkyscraper = 'building-skyscraper',
  BuildingStore = 'building-store',
  Calendar = 'calendar',
  CalendarWeek = 'calendar-week',
  Camera = 'camera',
  Cash = 'cash',
  Check = 'check',
  ChevronDown = 'chevron-down',
  ChevronLeft = 'chevron-left',
  ChevronRight = 'chevron-right',
  ChevronUp = 'chevron-up',
  Clipboard = 'clipboard',
  ClipboardOff = 'clipboard-off',
  CircleFilled = 'circle-filled',
  CircleCheckFilled = 'circle-check-filled',
  CircleX = 'circle-x',
  CircleXFilled = 'circle-x-filled',
  Cloud = 'cloud',
  CloudUpload = 'cloud-upload',
  Copy = 'copy',
  CreditCard = 'credit-card',
  DeviceFloppy = 'device-floppy',
  Dots = 'dots',
  DotsVertical = 'dots-vertical',
  Download = 'download',
  Edit = 'edit',
  Eye = 'eye',
  EyeOff = 'eye-off',
  EyeClosed = 'eye-closed',
  File = 'file',
  Files = 'files',
  FileCheck = 'file-check',
  FileOff = 'file-off',
  FilePlus = 'file-plus',
  FileSearch = 'file-search',
  FileStack = 'file-stack',
  FileTypeDoc = 'file-type-doc',
  FileTypeDocx = 'file-type-docx',
  FileTypeZip = 'file-type-zip',
  FileTypePdf = 'file-type-pdf',
  FileTypePng = 'file-type-png',
  FileTypeJpg = 'file-type-jpg',
  FolderCog = 'folder-cog',
  Folder = 'folder',
  HandMove = 'hand-move',
  Home = 'home',
  HomeEco = 'home-eco',
  InfoCircle = 'info-circle',
  MessageX = 'message-x',
  LayoutGrid = 'layout-grid',
  LayoutList = 'layout-list',
  Link = 'link',
  Lock = 'lock',
  LockPassword = 'lock-password',
  Login = 'login',
  Logout = 'logout',
  MapPin = 'map-pin',
  Menu2 = 'menu-2',
  Message = 'message',
  Message2 = 'message-2',
  MessageCircle = 'message-circle',
  MessageReport = 'message-report',
  MessageQuestion = 'message-question',
  Microphone = 'microphone',
  NoteOff = 'note-off',
  Paperclip = 'paperclip',
  Pencil = 'pencil',
  Phone = 'phone',
  Photo = 'photo',
  Plus = 'plus',
  Refresh = 'refresh',
  Receipt = 'receipt',
  Repeat = 'repeat',
  Robot = 'robot',
  Scale = 'scale',
  Seedling = 'seedling',
  Search = 'search',
  Send = 'send',
  Settings = 'settings',
  Signature = 'signature',
  Star = 'star',
  StarFilled = 'star-filled',
  Trash = 'trash',
  Truck = 'truck',
  Upload = 'upload',
  UserCheck = 'user-check',
  UserCircle = 'user-circle',
  UserShield = 'user-shield',
  UserDown = 'user-down',
  UserPlus = 'user-plus',
  UserStar = 'user-star',
  UserEdit = 'user-edit',
  WritingSign = 'writing-sign',
  X = 'x',
  ZoomIn = 'zoom-in',
  ZoomOut = 'zoom-out',
  Leaf = 'leaf',
  SignLeft = 'sign-left',
  CurrentLocation = 'current-location',
  Ruler = 'ruler',
  Stack2 = 'stack-2',
  Tools = 'tools',
  WorldLatitude = 'world-latitude',
  MapPinStar = 'map-pin-star',
}
